import { initDataOnStartup } from "./modules/utils";

initDataOnStartup();
